import React from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ESpacing } from '@aquariuxfintech/aqx-trader-react-ui/foundation';

import { AUTHENTICATION_ROUTES } from '@aqx-core/common/constants/router';

import AuthFormSecondaryAction from '../../shared/form-secondary-action';
import SignUpCrmBasicForm from './form';

const SignUpCrmBasic: FCC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StyledContainer>
      <SignUpCrmBasicForm />
      <AuthFormSecondaryAction
        infoText={t('Already have an account?')}
        actionText={t('Sign In')}
        onClickActionText={() => navigate(AUTHENTICATION_ROUTES.LOGIN)}
      />
    </StyledContainer>
  );
};

export default SignUpCrmBasic;

const StyledContainer = styled.div`
  width: 512px;
  display: flex;
  flex-direction: column;
  gap: ${ESpacing.XL}px;
`;
